import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://qarshisu.net/forms",
  headers: {
    "ngrok-skip-browser-warning": "true",
  },
});

export default axiosInstance;
